var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 141,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef9",
    d: "M71.118 124.837c32.8 0 59.4-26.4 59.4-59s-26.6-59-59.4-59-59.4 26.4-59.4 59 26.6 59 59.4 59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5ddea",
    d: "M116.618 58.136v36.1c0 7.501-6.1 13.601-13.7 13.601h-63.4c-7.5 0-13.6-6-13.7-13.5v-36.4c0-.2 0-.4.1-.6.1-.3.2-.5.3-.8l17-32.5c.6-1.3 1.9-2 3.3-2h49.3c1.4 0 2.6.7 3.3 2l17 32.5c.1.2.2.5.3.8.2.2.2.5.2.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M116.618 58.136v39.8c0 5.501-4.4 9.901-10 9.901h-70.8c-5.5 0-10-4.4-10-9.9v-40c0-.2 0-.4.1-.6h22.8c3.4 0 6.2 2.7 6.2 6.2 0 1.7.7 3.3 1.8 4.4 1.2 1.2 2.6 1.8 4.4 1.8h20.3c3.4 0 6.2-2.7 6.2-6.2 0-1.7.7-3.3 1.8-4.4 1.2-1.2 2.6-1.8 4.3-1.8h22.7c.2.2.2.5.2.8z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef9",
    d: "M129 37.636a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m-4.1-13.299a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6M11.5 33.536a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6M5.2 95.137a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#abb5cc",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M96.238 10.006c1.305 14.247 1.957 17.51-.998 30.412-.96 2.869-1.921 6.01-3.98 8.196-2.883 3.415-8.1 4.918-12.355 3.825-4.393-1.093-7.962-4.918-8.786-9.562-.686-2.869.275-6.284 2.746-8.06 2.608-1.638 6.315-1.229 8.51.82 2.472 2.05 3.433 5.191 3.295 8.196s-1.235 6.01-2.745 8.606c-3.413 6.381-4.819 6.358-11.805 16.839"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dae2eb",
    d: "M103.891 4.7c-.521 1.903-2.609 2.595-4.696 1.384-2.26-1.038-3.826-1.904-3.478-3.635C96.239.72 98.326.546 100.76.373c2.956-.347 3.478 2.423 3.13 4.326zM87.02 6.43c.87 1.558 3.305 2.596 5.044 1.038 1.913-1.73 3.479-2.942 2.61-4.673-.87-1.557-2.262-1.038-5.219-.692-2.435.52-3.478 2.596-2.435 4.327"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#989fb0",
    d: "M94.673.027c1.218-.174 2.435.519 2.783 1.557.174.346.348.866.348 1.212.347 2.423-.522 4.5-1.913 4.673-1.566.346-3.131-1.385-3.305-3.635V2.276c.174-1.211.87-2.076 2.087-2.25 0 0 .174 0 0 0zM59.808 84.096a2.294 2.294 0 1 0 0-4.588 2.294 2.294 0 0 0 0 4.588m22.819 0a2.294 2.294 0 1 0 0-4.588 2.294 2.294 0 0 0 0 4.588m-7.689 15.068h-7.193a2.064 2.064 0 0 1-2.046-2.046c0-1.116.93-2.046 2.046-2.046h7.131c1.116 0 2.046.93 2.046 2.046.062 1.116-.868 2.046-1.984 2.046"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 71.188,
    x2: 71.188,
    y1: 56.168,
    y2: 108.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ecf0f5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 134.8,
    height: 94.5,
    x: 3.818,
    y: 46.337,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1706_2660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1706_2660",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/noTransaction.2cfe4b00c062f7ad4a9a93d3de91d2f7.svg";
export { ForwardRef as ReactComponent };